// Re-export any shared constants from lib-js-common
export * from '@uw-it-sis/lib-js-common/lib/Constants.js';

/**
 *  Constants common to all the  Apps
 */
export const FORBIDDEN_URL_KEY = "themes/ksap/templates/403.jsp";
export const NOT_FOUND_URL_KEY = "themes/ksap/templates/404.jsp";

export const DEFAULT_ANALYTICS_BUFFER_SIZE = 10;

export const AUTH_FLOW_PROCEED_TO_IDP = "idp";
export const AUTH_FLOW_DISPLAY_LOGIN = "disco";

export const States = {
    initial: "initial",
    done: "done",
    pending: "pending",
    unauthenticated: "unauthenticated",
    maintenance: "maintenance",
    error: "error",
    unauthorized: "unauthorized"
};

export const DaysOfWeek = [
    {key: "monday", shortCode: "M", index: 1},
    {key: "tuesday", shortCode: "T", index: 2},
    {key: "wednesday", shortCode: "W", index: 3},
    {key: "thursday", shortCode: "Th", index: 4},
    {key: "friday", shortCode: "F", index: 5},
    {key: "saturday", shortCode: "S", index: 6}
];

export const Breakpoints = {
    xs: {
        code: "xs",
        width: 0 },
    sm: {
        code: "sm",
        width: 576 },
    md: {
        code: "md",
        width: 768 },
    lg: {
        code: "lg",
        width: 992 },
    xl: {
        code: "xl",
        width: 1200 }
};

// the list of properties that can be updated at runtime on the session user object
// Only allow updating the campus and the schedule builder onboarding flag
export const UpdateableUserAttributes = [
    "preferredCampus",
    "sbOnboardingFlag"
];

export const Campus = Object.freeze({
    seattle: "seattle",
    bothell: "bothell",
    tacoma: "tacoma"
});
